import { ShieldCheck, Truck, Users, Heart } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "VEILIG BETALEN", sub: "via betrouwbare partners" },
  { icon: Truck, title: "OPHALEN OF BEZORGEN", sub: "jij kiest" },
  { icon: Users, title: "JIJ EN DE ANDER", sub: "houden controle" },
  { icon: Heart, title: "SAMEN MAKEN WE", sub: "Vrijmarkt beter" },
];

export function FeatureBar() {
  return (
    <div className="rounded-2xl border border-[#333] bg-[#1c1c1c] p-6 md:p-8">
      <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
        {items.map((it) => (
          <div key={it.title} className="flex flex-col items-center gap-2 text-center md:flex-row md:text-left">
            <it.icon className="h-8 w-8 shrink-0 text-[#FF6A00]" />
            <div>
              <p className="font-display text-sm tracking-wide text-[#F5F5F5]">{it.title}</p>
              <p className="text-sm text-[#A0A0A0]">{it.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
